// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2uyms","obliqueLineWrap":"membershipbadge_obliqueLineWrap__18d5B","obliqueLine":"membershipbadge_obliqueLine__1o2X6"};